import { MIN_USERNAME_LENGTH, MAX_USERNAME_LENGTH } from '@colonist/consts';
export function getUsernameValidationMessage(validation, options) {
    if (options.isValidating) return undefined;
    if (validation.type == 'valid') return undefined;
    if (validation.type == 'isSame' && !options.hasEdited) return undefined;
    return getValidationMessageForResult(validation);
}
function getValidationMessageForResult(validation) {
    switch(validation.type){
        case 'isSame':
            return {
                key: 'strings:homePage.header.changeUsername.validationMessage.notDifferent'
            };
        case 'invalidLength':
            return {
                key: 'strings:homePage.header.changeUsername.validationMessage.invalidLength',
                options: {
                    minLength: MIN_USERNAME_LENGTH,
                    maxLength: MAX_USERNAME_LENGTH
                }
            };
        case 'nonAlphanumeric':
            return {
                key: 'strings:homePage.header.changeUsername.validationMessage.nonAlphanumeric'
            };
        case 'hasBadWords':
            return {
                key: 'strings:homePage.header.changeUsername.validationMessage.hasBadWords'
            };
        case 'isTaken':
            return {
                key: 'strings:homePage.header.changeUsername.validationMessage.notAvailable'
            };
        default:
            return undefined;
    }
}
